"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user = void 0;

var actions = _interopRequireWildcard(require("../constants"));

var _helpers = require("../helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Initial State */
var initialState = {
  token: undefined,
  tokenContent: undefined,
  isFetching: false,
  user: undefined,
  error: undefined
};
/* Reducer */

var user = function user(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case actions.LOG_IN_REQUEST:
    case actions.SUBMIT_SELF_REGISTRATION_REQUEST:
    case actions.RESET_PASSWORD_REQUEST:
    case actions.READ_USER_DETAILS_REQUEST:
    case actions.USER_VERIFY_REQUEST:
    case actions.SELF_REGISTER_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.RESET_PASSWORD_SUCCESS:
    case actions.SUBMIT_SELF_REGISTRATION_SUCCESS:
    case actions.USER_REGISTER_SUCCESS:
    case actions.SELF_REGISTER_SUCCESS:
      return _extends({}, state, action.payload, {
        isFetching: false,
        error: undefined
      });

    case actions.LOG_IN_SUCCESS:
      (0, _helpers.saveOrganisationToCookie)(action.payload.user.myOrganisationId);
      return _extends({}, state, {
        user: _extends({}, action.payload.user),
        isFetching: false,
        error: undefined
      });

    case actions.READ_USER_DETAILS_SUCCESS:
      return _extends({}, state, {
        user: _extends({}, action.payload),
        isFetching: false,
        error: undefined
      });

    case actions.SUBMIT_SELF_REGISTRATION_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.LOG_IN_FAILURE:
    case actions.READ_USER_DETAILS_FAILURE:
    case actions.USER_VERIFY_FAILURE:
    case actions.SELF_REGISTER_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.RESET_PASSWORD_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.LOG_OUT_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.LOG_OUT_SUCCESS:
      return initialState;

    case actions.REFRESH_TOKEN_FAILURE:
      return _extends({}, initialState, {
        error: 'User session expired'
      });

    case actions.USER_REGISTER_FAILURE:
      return _extends({}, initialState, {
        error: 'Registration failed. ' + action.error + ' If issue persists, please contact your account administrator.'
      });

    case actions.LOG_OUT_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.FORGOT_PASSWORD_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.FORGOT_PASSWORD_SUCCESS:
      return _extends({}, state, {
        isFetching: false,
        error: undefined
      });

    case actions.FORGOT_PASSWORD_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.DECODE_TOKEN_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.DECODE_TOKEN_SUCCESS:
      return _extends({}, state, {
        tokenContent: action.payload,
        isFetching: false,
        error: undefined
      });

    case actions.DECODE_TOKEN_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.REFRESH_TOKEN_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.CLEAR_LOGIN_FORM:
    case actions.REFRESH_TOKEN_SUCCESS:
      return _extends({}, state, {
        isFetching: false,
        error: undefined
      });

    case actions.USER_UPDATE_SUCCESS:
    case actions.USER_VERIFY_SUCCESS:
      return _extends({}, state, {
        user: _extends({}, action.payload),
        isFetching: false,
        error: undefined
      });

    default:
      return state;
  }
};

exports.user = user;